import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

import { EContractStatus, EManagementType } from "api/enums";
import AttachmentsContract from "components/Attachments/AttachmentsContract";
import DatePickerField from "components/UI/Fields/DatePickerField";
import { lang } from "i18nLang";

const FormContract = ({
  data,
  validated,
  editClient,
  isEditing,
  disabledManagmentType = false,
  onInputChange,
  onInputBlur,
}: {
  data: {
    contractName: string;
    projectName: string;
    location: string;
    client: string;
    contractDate?: Date;
    managementType: string;
    status: string;
  };
  validated: any;
  editClient: boolean;
  isEditing: boolean;
  disabledManagmentType?: boolean;
  onInputChange: (ev: any) => void;
  onInputBlur: (ev: any) => void;
}) => {
  const statusOptions = Object.values(EContractStatus);

  return (
    <>
      <TextField
        id="inpContractProjectName"
        name="projectName"
        label={lang("fields.project")}
        value={data.projectName}
        onChange={onInputChange}
        onBlur={onInputBlur}
        onKeyDown={(ev) => ev.stopPropagation()}
        margin="normal"
        required={true}
        fullWidth
        error={!validated.projectName.valid}
        helperText={validated.projectName.text}
      />
      <TextField
        id="inpContractName"
        name="contractName"
        label={lang("fields.contract")}
        value={data.contractName}
        onChange={onInputChange}
        onBlur={onInputBlur}
        onKeyDown={(ev) => ev.stopPropagation()}
        margin="normal"
        required={true}
        fullWidth
        error={!validated.contractName.valid}
        helperText={validated.contractName.text}
      />
      {editClient && (
        <TextField
          id="inpContractClient"
          name="client"
          label={lang("fields.client")}
          value={data.client}
          error={!validated.client.valid}
          helperText={validated.client.text}
          onChange={onInputChange}
          onBlur={onInputBlur}
          onKeyDown={(ev) => ev.stopPropagation()}
          margin="normal"
          required={true}
          fullWidth
        />
      )}
      <TextField
        id="inpContractLocation"
        name="location"
        label={lang("fields.location")}
        value={data.location}
        error={!validated.location.valid}
        helperText={validated.location.text}
        onChange={onInputChange}
        onBlur={onInputBlur}
        onKeyDown={(ev) => ev.stopPropagation()}
        margin="normal"
        required={true}
        fullWidth
      />
      <DatePickerField
        id="inpContractDate"
        name="contractDate"
        label={lang("fields.contractDate")}
        margin="normal"
        value={data.contractDate}
        onChange={(value) =>
          onInputChange({ target: { name: "contractDate", value } })
        }
        onBlur={(name, newDate) =>
          onInputBlur({ target: { name, value: newDate } })
        }
        fullWidth
        disableFuture
        error={!validated.contractDate.valid}
        helperText={validated.contractDate.text}
        disabled={isEditing}
      />
      <FormControl fullWidth={true} margin="normal">
        <InputLabel id="selContractManagementTypeLabel">
          {lang("fields.executionRegime")}
        </InputLabel>
        <Select
          labelId="selContractManagementTypeLabel"
          id="selContractManagementType"
          name="managementType"
          value={data.managementType}
          onChange={onInputChange}
          disabled={disabledManagmentType}
        >
          <MenuItem value={EManagementType.GLOBAL}>
            {lang("contract.executionRegime.global")}
          </MenuItem>
          <MenuItem value={EManagementType.UNIT_PRICE}>
            {lang("contract.executionRegime.unitPrice")}
          </MenuItem>
        </Select>
      </FormControl>
      <TextField
        id="selContractStatus"
        name="status"
        label={lang("contract.status")}
        value={data.status}
        select={true}
        onChange={onInputChange}
        onBlur={onInputBlur}
        onKeyDown={(ev) => ev.stopPropagation()}
        margin="normal"
        fullWidth
      >
        {statusOptions.map((stt) => (
          <MenuItem key={stt} value={stt}>
            {lang(`kanban.status.${stt}`)}
          </MenuItem>
        ))}
      </TextField>
      <AttachmentsContract isEditing={isEditing} />
    </>
  );
};

export default FormContract;
